import "./style.css";
import logo from '../../Images/logo.png'
import { useState,useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton,ThemeProvider,createTheme } from "@mui/material";
import whats from '../../Images/icons/whats.png'
import face from "../../Images/icons/face.png";
import insta from '../../Images/icons/insta.png'
import tik from '../../Images/icons/tik.png'
import snap from '../../Images/icons/snap.png'
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,  
        sm: 600,
        md: 1080,  
        lg: 1280, 
      },
    },
    palette: {
      primary: {
        main: '#00897b',
        light: '#80cbc4',
        dark: '#00695c',
        contrastText: '#fff',
      },
    },
  });

function Header() {
    
      const location = useLocation();
  
      useEffect(() => {
          const pageTitle = location.pathname.split('/').pop();
          if (pageTitle===""){
            // eslint-disable-next-line no-useless-concat
            document.title =  'مركز سبأ منطقة الرجل'; 
          }else{
          document.title = 'مركز سبأ منطقة الرجل | '+decodeURIComponent(pageTitle); 
          }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [location]);
  

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [activeLink, setActiveLink] = useState('');
 
  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsOpen(false);
  };


  return (
    <ThemeProvider theme={customTheme}>
    <div className="header" id="header">
      <div className="navbar">
        <Link to="/">
        <img src={logo} alt="logo" className="logo" />
        </Link>
       
<div className="right-nav">
        <ol className={isOpen ? "none" : "linkList"}>
          <li>
          <a
                  href='/'
                  className={activeLink === 'الرئيسية' ? 'navLink active' : 'navLink'}
                  onClick={() => handleLinkClick('الرئيسية')}
                >
                الرئيسية
                </a>
             
          </li>
          <li>
            <a
             className={activeLink === 'الخدمات' ? 'navLink active' : 'navLink'}
             onClick={() => handleLinkClick('الخدمات')}
              href="/الخدمات"
            >
               الخدمات
            </a>
          </li>
          <li>
            <a
             className={activeLink === 'العروض' ? 'navLink active' : 'navLink'}
             onClick={() => handleLinkClick('العروض')}
              href="/العروض"
            >
               العروض
            </a>
          </li>
          <li>
          <a
                  href='/معرض الصور'
                  className={activeLink === 'معرض الصور' ? 'navLink active' : 'navLink'}
                  onClick={() => handleLinkClick('معرض الصور')}
                >
            معرض الصور
            </a>
          </li>
          <li>
            <a
              className={activeLink === 'تواصل معنا' ? 'navLink active' : 'navLink'}
              onClick={() => handleLinkClick('تواصل معنا')}
              href="/"
            >
              تواصل معنا
            </a>
          </li>
         
        </ol>
      
</div>
<a href="whatsapp://send?phone=+966550769152">
<Button variant="contained" color="primary" sx={{borderRadius:'15px'}}>احجز خدمتك</Button>
</a>
        <IconButton
          sx={{
            display: { lg: "none", md: "none",sm:'inline-block', xs: "inline-block" },
            top: 2,
            right: "0px",
            zIndex: 99,
          }}
          onClick={toggleMenu}
        >
          {!isOpen ? (
            <MenuIcon id="openIcon" sx={{ color: "#00897b" }} fontSize="small" />
          ) : (
            <CloseIcon
              id="closeIcon"
              sx={{ color: "#fff" }}
              fontSize="medium"
            />
          )}
        </IconButton>
        <div className={isOpen ? "linkMenu show" : "linkMenu"}>
        <ol id="navMenu" >
        <li>
          <a
                  href='/'
                  className={activeLink === 'الرئيسية' ? 'navLink active' : 'navLink'}
                  onClick={() => handleLinkClick('الرئيسية')}
                >
                الرئيسية
                </a>
             
          </li>
          <li className="separation"></li>
          <li>
            <a
             className={activeLink === 'الخدمات' ? 'navLink active' : 'navLink'}
             onClick={() => handleLinkClick('الخدمات')}
              href="/الخدمات"
            >
               الخدمات
            </a>
          </li>
          <li className="separation"></li>
          <li>
            <a
             className={activeLink === 'العروض' ? 'navLink active' : 'navLink'}
             onClick={() => handleLinkClick('العروض')}
              href="/العروض"
            >
               العروض
            </a>
          </li>
          <li className="separation"></li>
          <li>
          <a
                  href='/معرض الصور'
                  className={activeLink === 'معرض الصور' ? 'navLink active' : 'navLink'}
                  onClick={() => handleLinkClick('معرض الصور')}
                >
            معرض الصور
            </a>
          </li>
          <li className="separation"></li>
          <li>
            <a
              className={activeLink === 'تواصل معنا' ? 'navLink active' : 'navLink'}
              onClick={() => handleLinkClick('تواصل معنا')}
              href="/"
            >
              تواصل معنا
            </a>
          </li>
         <li className="separation"></li>
          <li>
            <div className="socialLinks">
            <a
            href="https://www.instagram.com/spamanarea/"
            target="_blank"
            rel="noreferrer"
          >
        <img src={insta} alt="facebook" className='socialIconHead' />
          </a> 
          <a
           href="https://www.facebook.com/profile.php?id=61571041986973"
            target="_blank"
            rel="noreferrer"
          >
        <img src={face} alt="insta" className='socialIconHead' />
          </a> 
          <a
            href="https://www.tiktok.com/@spamanarea"
            target="_blank"
            rel="noreferrer"
          >
         <img src={tik} alt="tik" className='socialIconHead' />
         </a>
         <a
            href="https://snapchat.com/t/flaOPhit"
            target="_blank"
            rel="noreferrer"
          >
             <img src={snap} alt="snap" className='socialIconHead' />
         </a>
         <a
            href="whatsapp://send?phone=+966550769152"
            target="_blank"
            rel="noreferrer"
          >
         <img src={whats} alt="whats" className='socialIconHead' />
         </a>
       
          
            </div>
          </li>
        </ol>
        </div>
      </div>
    </div>
    </ThemeProvider>
  );
}

export default Header;
